import * as R from 'ramda'
import {connect, Store as ReduxStore} from "react-redux";
import {CallbackProps, QueriesWidget, ValueProps} from "./presentation";
import {compose, Dispatcher, toStrings} from "../../lib/utils";
import {Action} from "redux";
import {QueriesWidgetAction, QueriesWidgetActionWrapper} from "./actions";
import {State} from "./reducers";
import {CategoryTreeItem} from "../../lib/category-manager/data";
import {Query, QueryCategoryMap} from "./data";

// This function can be found /php/src/communications_html.php
declare function setCommunicationRecipientListButton(vs: string, ls: string):void

export type Store = ReduxStore<State>

export type OwnProps = {
	store: Store
	categories: CategoryTreeItem[]
	queries: Query[]
	queryCategoryMap: QueryCategoryMap
}

const mapStateToProps = (state: State, ownProps: OwnProps): ValueProps => ({
	...R.omit(['titleMap', 'visibleQueries'], state),
	categories: ownProps.categories,
	queries: ownProps.queries.filter(q => state.visibleQueries.indexOf(q.id) >= 0)
})

const mapDispatchToProps = (dispatch: Dispatcher<Action, State>): CallbackProps => {
	const wrap = (action: QueriesWidgetAction): QueriesWidgetActionWrapper => ({
		type: 'queries widget action',
		action: action
	})
	const dispatchAction = compose(wrap, dispatch)

	return {
		setCategoryFilters: (categories) => dispatchAction({type: "set category filters", categories}),
		setQueryCheckbox: (query) => dispatch(async (dispatchUnwrapped, getState) => {
			dispatchAction({type: "set query checkbox", query})
			const state = getState()
			setCommunicationRecipientListButton(
				toStrings(state.selectedQueries).join(),
				selectedQueryLabels(state)
			)
		}),
		unsetQueryCheckbox: (query) => dispatch(async (dispatchUnwrapped, getState) => {
			dispatchAction({type: "unset query checkbox", query})
			const state = getState()
			setCommunicationRecipientListButton(
				toStrings(state.selectedQueries).join(),
				selectedQueryLabels(state)
			)
		})
	}
}

const selectedQueryLabels = (state: State) => {
	return state.selectedQueries.map((q) => state.titleMap[q]).join('<br />')
}

export const QueriesWidgetApp = connect<ValueProps, CallbackProps, OwnProps, State>(
	mapStateToProps,
	mapDispatchToProps
)(QueriesWidget)



// WEBPACK FOOTER //
// ./src/communications/queries-widget/app.ts